import { render, staticRenderFns } from "./OrcamentoOperacoes.vue?vue&type=template&id=1a7bb808&scoped=true"
import script from "./OrcamentoOperacoes.vue?vue&type=script&lang=js"
export * from "./OrcamentoOperacoes.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoOperacoes.vue?vue&type=style&index=0&id=1a7bb808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bb808",
  null
  
)

export default component.exports